import React from "react"
import OrderMetricsCardSkeleton from "../OrderHistoryDesktopSkeleton/OrderMetricsCardSkeleton"
import OrderHistoryCardSkeleton from "./OrderHistoryCardSkeleton"

const OrderMetricsSkeleton = () => {
  return (
    <>
      <div className="flex flex-row mx-auto">
        <OrderMetricsCardSkeleton />
        <OrderMetricsCardSkeleton />
      </div>
      <div className="flex flex-col mx-auto w-full mt-2">
        <OrderHistoryCardSkeleton />
        <OrderHistoryCardSkeleton />
        <OrderHistoryCardSkeleton />
      </div>
    </>
  )
}

export default OrderMetricsSkeleton
